<template>
  <div class="card-inside-container">
    <div :key="annonce.serverId" class="card other-annonce-card d-flex flex-column align-items-start"
         @click="goToAnnonce(annonce.serverId)">

      <!--      region titre & nbViews pour mon annonce-->
      <div v-if="fromMyAnnonce" class="w-100 d-flex justify-content-between mb-2">
        <div class="card-title-annonce vehicle-name">{{ annonce.vehicle.annonceName }}</div>

        <div class="d-flex align-items-center justify-content-between">
          <div :class="annonce.userHasSeenAnnonce ? 'seen-annonce' : 'not-seen-annonce'" class="view-label-others">
            <div v-if="annonce.nbViews > 122">
              <span class="ml-1">{{ annonce.nbViews }}</span>
            </div>
            <div v-else>
              <span class="ml-1">{{ $t('new.annonce') }}</span>
            </div>
            <svg class="mr-1" fill="none" height="19" viewBox="0 0 19 19" width="19" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.1595 9.27219C18.1349 9.21664 17.5393 7.89547 16.2153 6.57148C14.4512 4.80734 12.223 3.875 9.7705 3.875C7.318 3.875 5.0898 4.80734 3.32566 6.57148C2.00167 7.89547 1.40331 9.21875 1.38152 9.27219C1.34953 9.34413 1.33301 9.42198 1.33301 9.5007C1.33301 9.57943 1.34953 9.65728 1.38152 9.72922C1.40613 9.78477 2.00167 11.1052 3.32566 12.4292C5.0898 14.1927 7.318 15.125 9.7705 15.125C12.223 15.125 14.4512 14.1927 16.2153 12.4292C17.5393 11.1052 18.1349 9.78477 18.1595 9.72922C18.1915 9.65728 18.208 9.57943 18.208 9.5007C18.208 9.42198 18.1915 9.34413 18.1595 9.27219ZM9.7705 12.3125C9.21424 12.3125 8.67047 12.1475 8.20796 11.8385C7.74545 11.5295 7.38496 11.0902 7.17209 10.5763C6.95922 10.0624 6.90352 9.49688 7.01204 8.95131C7.12056 8.40574 7.38843 7.9046 7.78176 7.51126C8.1751 7.11793 8.67624 6.85006 9.22181 6.74154C9.76738 6.63302 10.3329 6.68872 10.8468 6.90159C11.3607 7.11446 11.8 7.47495 12.109 7.93746C12.4181 8.39997 12.583 8.94374 12.583 9.5C12.583 10.2459 12.2867 10.9613 11.7592 11.4887C11.2318 12.0162 10.5164 12.3125 9.7705 12.3125Z"
                fill="black"/>
            </svg>

          </div>
        </div>
      </div>
      <!-- endregion-->

      <div class="position-relative card-image-top-outer-container">
        <div class="card-image-top-container">
          <img v-if="annonce.vehicle.imagesVehicle.length > 0"
               :src="getFileUrl(annonce.vehicle.imagesVehicle[0].fileUrl)"
               class="card-img-top">
          <img v-else :src="require(`@/assets/images/b122/PLACEHOLDER.png`)" class="card-img-top">
          <div v-if="AnnonceUtils.isBoostStillValid(annonce.boostEndDate)" class="boost-icon-container">
            <i class="ph-lightning-fill"></i>
          </div>
        </div>
      </div>


      <div class="body-annonce mt-2 gap w-100">
        <!--        récompenses supplémentaires -->
        <div>
          <i v-for="index in 5"
             :class="(index <= annonce.additionnalRewardLevel ? 'ph-star-fill' : 'ph-star') + ' main-color'"></i>
        </div>

        <!--        titre pour les annonces des autres -->
        <div v-if="!fromMyAnnonce" class="card-title-annonce vehicle-name mb-2">{{ annonce.vehicle.annonceName }}</div>

        <!--        date-->
        <div v-if="!fromMyAnnonce" class="d-flex align-items-center mb-2">
          <i class="ph-custom ph-clock-counter-clockwise main-color"/>
          <span class="relative-date ml-2">{{ convertTimestampToRelativeDate(annonce.date) }}</span>
        </div>
        <!--        identifiant du véhicule -->
        <div class="d-flex align-items-center mb-2">
          <i class="ph-custom ph-scan main-color"/>
          <span class="relative-date ml-2">{{ getPlate(annonce.vehicle) }}</span>
        </div>
        <!--        localisation -->
        <div class="d-flex align-items-center w-100 mb-2">
          <i class="ph-custom ph-map-trifold main-color"/>
          <span v-if="!fromMyAnnonce"
                class="relative-date location-row ml-2">{{ getLocation(annonce.vehicle.theftPosition) }}</span>
          <span v-else-if="fromMyAnnonce" class="relative-date location-row ml-2">
            {{ getLocationExact(annonce.vehicle.theftPosition) }}
          </span>
        </div>

        <div v-if="fromMyAnnonce && annonce.status && annonce.status.value==='VALIDATED'"
             class="d-flex align-items-center mb-2 w-100">
          <div class="w-100 custom-border-top">
            <!--        date de restitution du véhicule -->
            <div v-if="annonce.vehicle && annonce.vehicle.vehiclePositionFinalDate" class="d-flex">
              <i class="ph-custom ph-check-circle main-green-color mt-2"/>
              <span class="relative-date ml-2 mt-2">
                {{ $t("annonce.vehicle.returned.date", {date: formatDate(annonce.vehicle.vehiclePositionFinalDate)}) }}
              </span>
            </div>
            <div v-else>
              <div v-if="!AnnonceUtils.isBoostStillValid(annonce.boostEndDate)"
                   class="d-flex align-items-center main-orange-color mt-2" @click="navigateToBoostAnnonce">
                <i class="ph-custom ph-lightning-fill"/>
                <span class="ml-2">
                  {{ $t('boost.page.title') }}
                </span>
              </div>
              <div class="d-flex align-items-center main-color mt-2" @click="navigateToAdditionnalReward">
                <i class="ph-custom ph-star-fill"/>
                <span class="ml-2">
                  {{
                    annonce.additionnalRewardLevel != null ? $t('annonce.card.modify.additional.reward') : $t('annonce.card.add.additional.reward')
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!--        region favoris & nbViews pour annonces des autres -->
        <div v-if="!fromMyAnnonce" class="d-flex justify-content-between">
          <div>
            <svg v-if="annonce.annonceFavorite" fill="none" height="19" viewBox="0 0 13 11" width="19"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.225 3.77344C12.225 7.32812 6.9384 10.2054 6.71326 10.3242C6.65392 10.356 6.5876 10.3727 6.52022 10.3727C6.45284 10.3727 6.38651 10.356 6.32717 10.3242C6.10204 10.2054 0.81543 7.32812 0.81543 3.77344C0.816373 2.93871 1.14939 2.13844 1.74143 1.5482C2.33347 0.957952 3.13617 0.625941 3.97344 0.625C5.02526 0.625 5.94617 1.07594 6.52022 1.83816C7.09426 1.07594 8.01518 0.625 9.067 0.625C9.90426 0.625941 10.707 0.957952 11.299 1.5482C11.891 2.13844 12.2241 2.93871 12.225 3.77344Z"
                fill="#E74A49"/>
            </svg>
          </div>

          <div class="d-flex align-items-center justify-content-between">
            <div :class="annonce.userHasSeenAnnonce ? 'seen-annonce' : 'not-seen-annonce'" class="view-label-others">
              <div v-if="annonce.nbViews > 122">
                <span class="ml-1">{{ annonce.nbViews }}</span>
              </div>
              <div v-else>
                <span class="ml-1">{{ $t('new.annonce') }}</span>
              </div>
              <svg class="mr-1" fill="none" height="19" viewBox="0 0 19 19" width="19"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.1595 9.27219C18.1349 9.21664 17.5393 7.89547 16.2153 6.57148C14.4512 4.80734 12.223 3.875 9.7705 3.875C7.318 3.875 5.0898 4.80734 3.32566 6.57148C2.00167 7.89547 1.40331 9.21875 1.38152 9.27219C1.34953 9.34413 1.33301 9.42198 1.33301 9.5007C1.33301 9.57943 1.34953 9.65728 1.38152 9.72922C1.40613 9.78477 2.00167 11.1052 3.32566 12.4292C5.0898 14.1927 7.318 15.125 9.7705 15.125C12.223 15.125 14.4512 14.1927 16.2153 12.4292C17.5393 11.1052 18.1349 9.78477 18.1595 9.72922C18.1915 9.65728 18.208 9.57943 18.208 9.5007C18.208 9.42198 18.1915 9.34413 18.1595 9.27219ZM9.7705 12.3125C9.21424 12.3125 8.67047 12.1475 8.20796 11.8385C7.74545 11.5295 7.38496 11.0902 7.17209 10.5763C6.95922 10.0624 6.90352 9.49688 7.01204 8.95131C7.12056 8.40574 7.38843 7.9046 7.78176 7.51126C8.1751 7.11793 8.67624 6.85006 9.22181 6.74154C9.76738 6.63302 10.3329 6.68872 10.8468 6.90159C11.3607 7.11446 11.8 7.47495 12.109 7.93746C12.4181 8.39997 12.583 8.94374 12.583 9.5C12.583 10.2459 12.2867 10.9613 11.7592 11.4887C11.2318 12.0162 10.5164 12.3125 9.7705 12.3125Z"
                  fill="black"/>
              </svg>

            </div>
          </div>
        </div>
        <!--endregion-->

      </div>
    </div>
  </div>
</template>

<script>
import AnnonceUtils from "../../utils/AnnonceUtils"

export default {
  name: "AnnonceCardImageTop",
  props: {
    annonce: {
      default: null,
      type: Object,
      required: true
    },
    fromMyAnnonce: {
      default: false,
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      AnnonceUtils: AnnonceUtils,
    }
  },

  methods: {
    getFileUrl(path) {
      return (window.location.hostname === "integration-grand-public-lamp.bleu122.com" ? "https://integration-lamp.bleu122.com" : process.env.SERVER_URL) + path
    },
    convertTimestampToRelativeDate(timestamp) {
      const currentTimestamp = Date.now();
      const diffInMs = currentTimestamp - timestamp;

      const secondsInMs = 1000;
      const minutesInMs = secondsInMs * 60;
      const hoursInMs = minutesInMs * 60;
      const daysInMs = hoursInMs * 24;
      const monthsInMs = daysInMs * 30; // Environ 30 jours par mois
      const yearsInMs = daysInMs * 365; // Environ 365 jours par an

      if (diffInMs < secondsInMs) {
        return "à l'instant";
      } else if (diffInMs < minutesInMs) {
        const secondsAgo = Math.floor(diffInMs / secondsInMs);
        return `il y a ${secondsAgo} ${secondsAgo === 1 ? 'seconde' : 'secondes'}`;
      } else if (diffInMs < hoursInMs) {
        const minutesAgo = Math.floor(diffInMs / minutesInMs);
        return `il y a ${minutesAgo} ${minutesAgo === 1 ? 'minute' : 'minutes'}`;
      } else if (diffInMs < daysInMs) {
        const hoursAgo = Math.floor(diffInMs / hoursInMs);
        return `il y a ${hoursAgo} ${hoursAgo === 1 ? 'heure' : 'heures'}`;
      } else if (diffInMs < monthsInMs) {
        const daysAgo = Math.floor(diffInMs / daysInMs);
        return `il y a ${daysAgo} ${daysAgo === 1 ? 'jour' : 'jours'}`;
      } else if (diffInMs < yearsInMs) {
        const monthsAgo = Math.floor(diffInMs / monthsInMs);
        return `il y a ${monthsAgo} ${monthsAgo === 1 ? 'mois' : 'mois'}`;
      } else {
        const yearsAgo = Math.floor(diffInMs / yearsInMs);
        return `il y a ${yearsAgo} ${yearsAgo === 1 ? 'an' : 'ans'}`;
      }
    },

    goToAnnonce(annonceId) {
      this.$router.push({
        name: 'AnnonceShow',
        params: {
          annonceId: annonceId
        }
      })
    },

    getLocation(pos) {
      if (pos.departement) {
        return pos.departement
      }
      return 'Non renseigné'
    },

    getPlate(vehicle) {
      let plateToReturn = ''
      if (vehicle.licensePlate) plateToReturn = vehicle.licensePlate
      else if (vehicle.vin) plateToReturn = vehicle.vin
      else if (vehicle.bicycode) plateToReturn = vehicle.bicycode
      else if (vehicle.serialNumber) plateToReturn = vehicle.serialNumber
      else return 'Non renseigné'
      return plateToReturn.substring(0, plateToReturn.length - 2) + '**'
    },
    getLocationExact(pos) {
      let output;
      if (!pos) {
        output = 'Non renseigné';
      } else {
        output = pos
      }

      return output
    },

    formatDate(timestamp) {
      const date = new Date(timestamp);
      const formatter = new Intl.DateTimeFormat('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: '2-digit'
      });
      return formatter.format(date);
    },

    navigateToAdditionnalReward() {
      this.$router.push({
        name: 'AnnonceAdditionnalRewardEdit',
        params: {
          annonceId: this.annonce.id
        }
      })
    },

    navigateToBoostAnnonce() {
      this.$router.push({
        name: 'AnnonceBoostEdit',
        params: {
          annonceId: this.annonce.id
        }
      })
    },
  }

}
</script>

<style scoped>

.card-image-top-outer-container {
  display: flex;
  width: 100%;
}

.card-image-top-container {
  height: 183px;
  display: flex;
  width: 100%;
}

.card-title-annonce {
  font-size: 15px;
}


@media (max-width: 768px) {

  .card-title-annonce {
    font-size: 14px;
  }

  .relative-date {
    min-width: 80px;
  }

  .view-label-others {
    padding: 1px 3px;
    min-width: 60px !important;
    font-size: 10px;
  }
}

.other-annonce-card {
  padding: 10px;
  border-radius: var(--fourth-border-radius);
}

.other-annonce-card .card-img-top {
  object-fit: cover;
  width: 100%;
  border-radius: 10px;
}


.other-annonces .card {
  display: flex;
  align-items: center;
}


.other-annonce-card .card-body {
  flex-grow: 1;
}


.body-annonce {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}


.relative-date {
  color: var(--main-grey-medium);
  font-size: 14px;
  display: flex;
  align-items: center;
  min-width: 100px;
}

.location-row {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.view-label-others {
  margin-right: -10px;
  padding: 2px 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 80px;
  height: 25px;
  border-radius: 2.5px 0 0 2.5px;
  color: var(--main-black-dark);
  font-weight: 700;
}

.not-seen-annonce {
  background: var(--main-yellow-medium);
}

.seen-annonce {
  background: var(--main-grey-light);
}

.vehicle-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  box-sizing: border-box;
  word-break: break-word;
}

.custom-border-bottom {
  border-bottom: 1px solid var(--main-grey-dark);
}

.custom-border-top {
  border-top: 1px solid var(--main-grey-dark);
}

</style>



// WEBPACK FOOTER //
// src/components/annonce/AnnonceCardImageTop.vue